export default __webpack_public_path__ + "static/bg2025_mobile@2x-2b513ba98ef65a68ecddb8f8d2cb074c.jpg";